import LanguagesAPI from '../api/Languages';
import ConfigurationAPI from '../api/Configuration';
import * as ActionTypes from '../constants/ActionTypes';
import * as LocalStorageUtils from '../utils/LocalStorage';
import * as LocalStorageConst from '../constants/LocalStorage';

import devjson from '../static/preLoad/dev'
import enjson from '../static/preLoad/en'
import esjson from '../static/preLoad/es'
import rujson from '../static/preLoad/ru'

import configurationDev from '../static/preLoad/configurationDev'
import configurationEn from '../static/preLoad/configurataionEn'
import configurationEs from '../static/preLoad/configurataionEs'
import configurationRu from '../static/preLoad/configurataionRu'

const LANGUAGES = {
    'dev': {
        i18n: devjson,
        conf: configurationDev,
    },
    'en': {
        i18n: enjson,
        conf: configurationEn,
        domain: "https://en.rentamania.es",
        imgUrl: "/static/imgs/languages/EN.png"
    },
    'es': {
        i18n: esjson,
        conf: configurationEs,
        domain: "https://rentamania.es",
        imgUrl: "/static/imgs/languages/ES.png"
    },
    'ru': {
        i18n: rujson,
        conf: configurationRu,
        domain: "https://ru.rentamania.es",
        imgUrl: "/static/imgs/languages/RU.png"
    }
};

export const initApp = () => dispatch => {
    let currentLanguageCode = getCurrentLanguage();

    // load configuration
    setConfigurationPreload(currentLanguageCode, dispatch);
    loadConfiguration(currentLanguageCode, dispatch);

    // load all Languages
    loadAllLanguages(dispatch);

    // load language
    setLanguagePreload(currentLanguageCode, dispatch);
    loadLanguage(currentLanguageCode, dispatch);

    // set current language
    setCurrentLanguage(currentLanguageCode, dispatch)
};

export const setGoogleApiInit = () => ({
    type: ActionTypes.SET_GOOGLE_API_INIT,
    payload: true
});

export const changeLanguage = code => dispatch => {
    let host = window.location.host;
    let arr = host.split('.');

    // если dev/localhost
    if (arr.length === 1 || arr[0] === 'dev') {
        setLanguagePreload(code, dispatch);
        loadLanguage(code, dispatch);

        setCurrentLanguage(code, dispatch);
        return
    }

    // если prod
    window.location.href = LANGUAGES[code].domain + window.location.pathname;
};

function setLanguagePreload(code, dispatch) {
    dispatch({
        type: ActionTypes.SET_I18N,
        payload: LANGUAGES[code].i18n
    });
}

function setConfigurationPreload(code, dispatch) {
    dispatch({
        type: ActionTypes.SET_CONFIGURATION,
        payload: LANGUAGES[code].conf
    });
}

function loadConfiguration(code, dispatch) {
    ConfigurationAPI.getConfiguration(code)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.SET_CONFIGURATION,
                payload: data
            });
        });
}

function loadLanguage(code, dispatch) {
    LanguagesAPI.getTranslateByCode(code)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.SET_I18N,
                payload: data
            });
        });
}

function loadAllLanguages(dispatch) {
    LanguagesAPI.getAllLanguages()
        .then(({data}) => {
            dispatch({
                type: ActionTypes.SET_ALL_LANGUAGES,
                payload: data
            });
        });
}

function setCurrentLanguage(code, dispatch) {
    LocalStorageUtils.set(LocalStorageConst.KEYS.LANGUAGE_CODE, code);
    dispatch({
        type: ActionTypes.SET_CURRENT_LANGUAGE,
        payload: {
            code: code,
            imgURL: LANGUAGES[code].imgUrl
        }
    });
}

function getCurrentLanguage() {
    let host = window.location.host;
    let arr = host.split('.');

    if (arr[0] === 'dev' || arr.length === 1) {
        let languageCode = LocalStorageUtils.get(LocalStorageConst.KEYS.LANGUAGE_CODE);
        if (languageCode === undefined || languageCode === null) {
            return "en";
        }

        return languageCode;
    }

    if (arr.length === 2) {
        return "es"
    } else {
        return arr[0]
    }
}



// WEBPACK FOOTER //
// ./src/actions/Global.js